module.exports = __webpack_public_path__ + "img/lPutH.ed3a6e38.svg";